import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Returning the component
class FormButton extends Component {
    render() {
        return (
            <button
                className={`form__button btn ${this.props.classType}`}
                id={this.props.id}
                type="submit"
                form={this.props.form}
                onClick={this.props.onClick}
                onChange={this.props.onChange}
            >
                <i className={`icon iconLeft fa ${this.props.iconLeft}`}></i>
                    {this.props.text}
                {this.props.iconClass ? <i className={`fa ${this.props.iconClass}`}></i> : false}
                <i className={`icon iconRight fa ${this.props.iconRight}`}></i>
            </button>
        )
    }
}


//Making sure that it has a text property when it's declared
FormButton.propTypes = {
	classType: PropTypes.string,
	form: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
	onChange: PropTypes.func,
	iconLeft: PropTypes.string,
	iconRight: PropTypes.string
}

export default FormButton;


// WEBPACK FOOTER //
// ./src/redux/components/atoms/FormButton.jsx